<template>
    <div class="fluid">
        <h1 class="app-title">GERAR REGISTRO DE INGRESSO DE RECEITA DIVERSA</h1>
        <b-card>
            <b-row no-gutters>
                <b-col md="12" no-gutters>
                    <form-wizard
                            ref="wizard"
                            nextButtonText="Próximo"
                            backButtonText="Anterior"
                            finishButtonText="Concluir"
                            title
                            subtitle
                            color="#0A9C70" >
                        <wizard-step
                                slot-scope="props"
                                slot="step"
                                :tab="props.tab"
                                :index="props.index"
                        ></wizard-step>
                        <tab-content
                                icon="fas fa-id-card"
                                class="mx-auto"
                                title="Indique os dados do Ingresso da Receita Diversa">
                            <DadosReceitasDiversas ref="dadosReceitasDiversas"
                                                   :receita-diversa="receitaDiversa"
                                                   :validations="validations"
                                                   :obrigatorio="obrigatorio"
                                                   :obrigatorio1="obrigatorio1"
                                                   :obrigatorio2="obrigatorio2"
                                                   :obrigatorio3="obrigatorio3"
                                                   :obrigatorio4="obrigatorio4"
                                                   :obrigatorio5="obrigatorio5"
                                @alterarValidadeValor="alterarValidadeValor"/>
                        </tab-content>
                        <tab-content
                                icon="fas fa-clipboard-check"
                                class="mx-auto"
                                title="Requisição Gerada" >
                            <ConclusaoReceitasDiversas :codigo-receita="codigoReceita"
                                                       :nova="receitaDiversa.codReceitasDiversas == null"
                                                       :codigo-parcela="codigoParcela"
                                                       @finalizar="finalizar()"/>
                        </tab-content>

                        <template slot="footer" slot-scope="props" class="pb-0">
                            <hr class="mt-0 mb-2"/>
                            <div class="row justify-content-between">
                                <b-col sm="12" md="2">
                                    <b-button
                                            v-if="props.activeTabIndex > 0 && !props.isLastStep"
                                            @click="props.prevTab()"
                                            variant="secondary" >
                                        <i class="fa fa-arrow-left"></i> Anterior
                                    </b-button>
                                </b-col>
                                <b-col sm="12" md="2" class="text-right">
                                    <b-button v-if="props.activeTabIndex == 0"
                                              @click="salvar" :disabled="load || !validations.valor.valid"
                                              variant="warning">
                                        Concluir Geração
                                        <i class="fa fa-file-pdf" v-if="!load"></i>
                                        <b-spinner small v-if="load"></b-spinner>
                                    </b-button>
                                </b-col>
                            </div>
                        </template>
                    </form-wizard>
                </b-col>
            </b-row>
        </b-card>
        <CompLoading ref="loading"/>
    </div>
</template>

<script>
    import {FormWizard, TabContent, WizardStep} from 'vue-form-wizard';
    import CompLoading from "../shared/components/CompLoading";

    import axios from 'axios';
    import 'vue-form-wizard/dist/vue-form-wizard.min.css';
    import DadosReceitasDiversas from "./components/DadosReceitasDiversas";
    import ConclusaoReceitasDiversas from "./components/ConclusaoReceitasDiversas";
    import formatarMixins from '../../mixins/formatarMixins';

    export default {
        mixins: [ formatarMixins ],
        components: {
            DadosReceitasDiversas,
            ConclusaoReceitasDiversas,
            FormWizard,
            TabContent,
            WizardStep,
            CompLoading,
        },
        data() {
            return {
            	obrigatorio: true,
            	obrigatorio1: true,
            	obrigatorio2: true,
            	obrigatorio3: true,
            	obrigatorio4: true,
            	obrigatorio5: true,
                ID_FORMA_PAGAMENTO_TRANSFERENCIA: 2,
                urlApi: null,
                token: null,
                codigoReceita: null,
                codigoParcela: null,
                receitaDiversa: {
                    codReceitasDiversas: null,
                    receita: null,
                    codDevedor: null,
                    cpfCnpjDevedor: null,
                    nomeDevedor: null,
                    valor: null,
                    formaPagamento: null,
                    observacoes: null,
                    dataTransferencia: null,
                    setor: null,
                    arquivos: []
                },
                
                load: false,
                validations: {
                    valor: { valid: true },
                    data: { pastDate: true },
                },
                
                
            }
        },
        methods: {
            async salvar() {
                if(!this.verificarObrigatoriedadereceita()) {
                   	 this.obrigatorio = false;
                }else
                {
               		 this.obrigatorio = true;
               	}
                
                if(!this.verificarObrigatoriedadedevedor()) {
                   	 this.obrigatorio1 = false;
                }else
                {
               		 this.obrigatorio1 = true;
                }
                
                if(!this.verificarObrigatoriedadevalor()) {
                   	 this.obrigatorio2 = false;
                }else
                {
               		 this.obrigatorio2 = true;
                }
                
                 if(!this.verificarObrigatoriedadesetor()) {
                   	 this.obrigatorio3 = false;
                }else
                {
               		 this.obrigatorio3 = true;
                }
                
                 if(!this.verificarObrigatoriedadeformapagamento()) {
                   	 this.obrigatorio4 = false;
                }else
                {
               		 this.obrigatorio4 = true;
                }
                
                if(!this.verificarObrigatoriedadedata() && this.receitaDiversa.formaPagamento === this.ID_FORMA_PAGAMENTO_TRANSFERENCIA) {
                   	 this.obrigatorio5 = false;
                }else
                {
               		 this.obrigatorio5 = true;
                }
                
                
                if (this.receitaDiversa.formaPagamento === this.ID_FORMA_PAGAMENTO_TRANSFERENCIA
                    && this.verificarValorVazio(this.receitaDiversa.dataTransferencia)) {
                        this.$refs['dadosReceitasDiversas'].validarDataTransferencia()
                        return
                }

                if (this.obrigatorio==true && this.obrigatorio1==true  && this.obrigatorio2==true
                        && this.obrigatorio3==true && this.obrigatorio4 && this.obrigatorio5==true
                        && this.validations.data.pastDate==true) {
                
                let receitaDiversaSalvar = {
                    ...this.receitaDiversa
                };

                receitaDiversaSalvar.valor = this.tratarCamposNumericos(receitaDiversaSalvar.valor);

                this.load = true;
                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/receitasDiversas/salvar`, receitaDiversaSalvar, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.codigoReceita = response.data.id;
                    this.codigoParcela = response.data.codigoParcela;
                    this.$refs.wizard.nextTab();
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.load = false;
                    this.$refs.loading.hideLoading();
                });
                }
            },
            verificarObrigatoriedadereceita() {
              return !this.verificarValorVazio(this.receitaDiversa.receita); 
              
            },
            
            verificarObrigatoriedadedevedor() {
              return !this.verificarValorVazio(this.receitaDiversa.cpfCnpjDevedor);
            },
            
            verificarObrigatoriedadevalor() {  
              return !this.verificarValorVazio(this.receitaDiversa.valor) 
            },
            
            verificarObrigatoriedadesetor() {  
              return !this.verificarValorVazio(this.receitaDiversa.setor);
            },
            
            verificarObrigatoriedadeformapagamento() {   
              return !this.verificarValorVazio(this.receitaDiversa.formaPagamento);
            },
            
            verificarObrigatoriedadedata() {   
              return !this.verificarValorVazio(this.receitaDiversa.dataTransferencia);
            },
            
            verificarValorVazio(valor) {
              return valor == null || valor === "";
            },
            async obterReceitaDiversa(id) {
                this.$refs.loading.showLoading();
                await axios.get(`${this.urlApi}/v1/receitasDiversas/obter/` + id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.receitaDiversa = response.data;

                    let valor = null;
                    if(this.receitaDiversa.valor != null) {
                        valor = this.receitaDiversa.valor.toString();
                        if(valor.split(".").length <= 1) {
                            valor += "00";
                        } else if(valor.split(".")[1].length == 1) {
                            valor += "0";
                        }
                    }
                    this.receitaDiversa.valor = this.formatarMonetario(valor);
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
            },
            finalizar () {
                this.$store.commit("setMessages", {})
                this.$store.commit('setReceitaDiversa', null)

                this.codigoReceita = null
                this.codigoParcela = null
                this.receitaDiversa = {
                    codReceitasDiversas: null,
                    receita: null,
                    codDevedor: null,
                    cpfCnpjDevedor: null,
                    nomeDevedor: null,
                    valor: null,
                    formaPagamento: null,
                    observacoes: null,
                    dataTransferencia: null,
                    setor: null,
                    arquivos: []
                }

                this.$refs.wizard.prevTab()
            },
            alterarValidadeValor(valido) {
                this.validations.valor.valid = valido;
            }
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            let receitaDiversa = this.$store.getters.getReceitaDiversa;
            if(receitaDiversa) {
                this.$store.commit('setReceitaDiversa', null);
                this.obterReceitaDiversa(receitaDiversa);
            }
        },
    }
</script>

<style>
    .stepTitle {
        display: none;
    }

    .stepTitle.active {
        display: block !important;
    }
</style>
